import React from "react";
import styles from "./IconTitleBox.module.scss";
import clsx from "clsx";
import DaySvg from "./../../../assets/images/24Hour.svg";
import AirconSvg from "./../../../assets/images/AirConditioner.svg";
import CctvSvg from "./../../../assets/images/CCTV.svg";
import ChalkboardSvg from "./../../../assets/images/Chalkboard.svg";
import CleaningSvg from "./../../../assets/images/Cleaning.svg";
import CoffeeSvg from "./../../../assets/images/Coffee.svg";
import CupSvg from "./../../../assets/images/Cup.svg";
import DeskSvg from "./../../../assets/images/Desk.svg";
import DoorLockSvg from "./../../../assets/images/DoorLock.svg";
import DrawerSvg from "./../../../assets/images/Drawer.svg";
import InternetSvg from "./../../../assets/images/Internet.svg";
import LockerSvg from "./../../../assets/images/Locker.svg";
import LoungeSvg from "./../../../assets/images/Lounge.svg";
import MailboxSvg from "./../../../assets/images/Mailbox.svg";
import MakeupSvg from "./../../../assets/images/Makeup.svg";
import MapSvg from "./../../../assets/images/Map.svg";
import MassageChairSvg from "./../../../assets/images/MassageChair.svg";
import MicrowaveSvg from "./../../../assets/images/Microwave.svg";
import MonitorSvg from "./../../../assets/images/Monitor.svg";
import ParcelSvg from "./../../../assets/images/Parcel.svg";
import ParkingSvg from "./../../../assets/images/Parking.svg";
import PhoneBoothSvg from "./../../../assets/images/PhoneBooth.svg";
import PrinterSvg from "./../../../assets/images/Printer.svg";
import RefrigeratorSvg from "./../../../assets/images/Refrigerator.svg";
import VentilatorSvg from "./../../../assets/images/Ventilator.svg";
import WatterPurifierSvg from "./../../../assets/images/WatterPurifier.svg";
import WiFiSvg from "./../../../assets/images/WiFi.svg";
import KettleSvg from "./../../../assets/images/Kettle.svg";
import SnacksSvg from "./../../../assets/images/Snacks.svg";

const IconTitleBox = ({ item, width = "24", height = "24" }) => {
  return (
    <div className={styles.container}>
      <div className={styles.container__iconbox}>
        {item === "기본 데스크" && (
          <DeskSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "개별 서랍장" && (
          <DeskSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "개별 디지털 도어록" && (
          <DoorLockSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "개별 냉난방" && (
          <AirconSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "공용 냉난방" && (
          <AirconSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "초고속 인터넷" && (
          <WiFiSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "보안 시스템" && (
          <CctvSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "공용 라운지" && (
          <LoungeSvg width={width} height={height} fill="#282d32" />
        )}
        {item === "24시간 이용 가능" && (
          <DaySvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "대형 모니터" && (
          <MonitorSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "화이트보드" && (
          <ChalkboardSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "탕비실" && (
          <KettleSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "전자레인지" && (
          <MicrowaveSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "무료 커피" && (
          <CoffeeSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "냉장고" && (
          <RefrigeratorSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "정수기" && (
          <WatterPurifierSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "폰 부스" && (
          <PhoneBoothSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "파우더룸" && (
          <MakeupSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "안마의자" && (
          <MassageChairSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "사물함" && (
          <LockerSvg width={width} height={height} fill=" #282d32" />
        )}
        {item === "간식 구매 가능" && (
          <SnacksSvg width={width} height={height} fill=" #282d32" />
        )}
        <span className={styles.container__iconbox_title}>{item}</span>
      </div>
    </div>
  );
};

export default IconTitleBox;
